import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  SEND_AECB_FTS_AUTHORIZATION,
  sendAuthorizationSuccess,
  sendAuthorizationFail
} from "../actions/sendAecbFtsEmail";
import { sendAecbFtsEmail } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { getAuthorizationHeader, getProspectId } from "../selectors/appConfig";

export function* sendAecbFtsEmailSaga({ payload }) {
  try {
    const state = yield select();
    const prospectId = yield select(getProspectId);
    const headers = getAuthorizationHeader(state);
    yield call(sendAecbFtsEmail.sendMail, payload, headers, prospectId);
    yield put(sendAuthorizationSuccess());
  } catch (error) {
    yield put(sendAuthorizationFail({}));
    log(error);
  }
}

export default function* sendAecbFtsEmailSagas() {
  yield all([takeLatest(SEND_AECB_FTS_AUTHORIZATION, sendAecbFtsEmailSaga)]);
}
